import { Box, Grid, Typography } from "@mui/material";
import { Container } from "@mui/system";
import React from "react";
import { BlueSection } from "../../styles/HomeStyles";

const Footer = () => {
  return (
    <BlueSection sx={{ marginTop: "-25px" }}>
      <Container sx={{ mb: 2, paddingTop: "25px" }}>
        <Grid container spacing={4} justifyContent="center">
          <Grid item xs={12} md>
            <Typography variant="h4" color="#FFF">
              AFRIQUALEOS
            </Typography>
          </Grid>
          <Grid item xs={12} md>
            <Typography variant="h6" color="#FFF">
              Adresse :
            </Typography>
            <Typography color="#FFF">
              67 Rue Aziz Bellal, 2eme Etage N°3 Maarif, Casablanca, Maroc
            </Typography>
          </Grid>
          <Grid item xs={12} md>
            <Typography variant="h6" color="#FFF">
              Email :
            </Typography>
            <Typography color="#FFF">contact@afriqualeos.com</Typography>
          </Grid>
        </Grid>
      </Container>
    </BlueSection>
  );
};

export default Footer;
